import axios from "axios";
import Configurator from "../config/Configurator";

export async function retrievePLCinfos(shipSerial) {
  try {
    // Get the API URL from your configuration
    const configData = await Configurator();
    const url = configData.API_URL + "/v2/io/devices/get";

    // Make the POST request with the transmitterSerial in the request body and include custom headers
    const response = await axios.post(
      url,
      {
        data: {
          source: shipSerial,
        },
      },
      {
        headers: {
          Session: localStorage.getItem("apiKey"),
          "User-Id": localStorage.getItem("userID"),
        },
      }
    );
    // Extract the Devices array from the response (fallback to an empty array)
    const devices = response.data.data.devices || [];
    return devices;
  } catch (error) {
    console.error("Error fetching PLC infos:", error);
    return [];
  }
}
